// Temporary launch gate. Keep existing orders and restaurant settings intact.
export const WE_PEDIDOS_AVAILABLE = false;
export const WE_PEDIDOS_UNAVAILABLE_MESSAGE =
  "We! pedidos todavia no esta disponible. Proximamente.";

export const isWePedidosIntakeBlocked = (action, sourceChannel = "") =>
  !WE_PEDIDOS_AVAILABLE && (
    action === "discover" || action === "we_session" ||
    (action === "create_order" && String(sourceChannel).trim().toLowerCase() === "we_pedidos")
  );
